import React, {useEffect, useState} from 'react';

import {SelectInput} from '../utils/SelectInput';
import {ButtonWithLoading} from '../utils/ButtonWithLoading';
import {TextArea} from '../utils/TextArea';
import {MonedaInputV2} from '../ui/moneda';
import {CheckBox} from '../ui/Checkbox';
import {DateInput} from '../utils/DateInput';
import {
  constants,
  prepareDatosAuxOptions,
  responseSelector,
  toTitleCase,
} from '../utils/utils';
import {useDispatch, useSelector} from 'react-redux';
import {Alert, alertTypes} from '../ui/alert';
import {
  getCargosDuck,
  getCargosThunk,
  getEmpresasThunk,
  getRubrosDuck,
  getRubrosThunk,
} from '../oportunidades/duck';
import {EmpresaAutocomplete} from '../ui/EmpresaAutocomplete';
import {
  crearCandidatoExpDuck,
  crearCandidatoExpThunk,
  getSalidaMotivosDuck,
  getSalidaMotivosThunk,
} from './duck';
import {empleoTipoOptionsForCandExp} from '../utils/constants';

export const AgregarExperienciaView = ({
  token,
  candidatoIdNumerico,
  onError,
  onSuccess,
}) => {
  const dispatch = useDispatch();
  const modelGetRubros = useSelector(state => state.getRubros);
  const modelCrearCandidatoExp = useSelector(state => state.crearCandidatoExp);
  const modelGetSalidaMotivos = useSelector(state => state.getSalidaMotivos);
  const modelGetCargos = useSelector(state => state.getCargos);

  const [empresaOption, setEmpresaOption] = useState(null);
  const [observacion, setObservacion] = useState('');
  const [vigente, setVigente] = useState(false);
  const [inicioFecha, setInicioFecha] = useState();
  const [finFecha, setFinFecha] = useState();
  const [salario, setSalario] = useState('');
  const [condicionesActuales, setCondicionesActuales] = useState('');
  const [cargoOptionExp, setCargoOptionExp] = useState();
  const [rubrosOptions, setRubrosOptions] = useState();
  const [rubroOption, setRubroOption] = useState();
  const [tipoEmpleoOption, setTipoEmpleoOption] = useState();
  const [salidaMotivoOptions, setSalidaMotivoOptions] = useState();
  const [salidaMotivoOption, setSalidaMotivoOption] = useState();

  const [cargosOptions, setCargosOptions] = useState([]);

  useEffect(() => {
    dispatch(
      getEmpresasThunk({
        esCliente: true,
        userToken: token.raw,
      }),
    );
    dispatch(
      getCargosThunk({
        userToken: token.raw,
      }),
    );
    dispatch(
      getRubrosThunk({
        userToken: token.raw,
      }),
    );
    dispatch(
      getSalidaMotivosThunk({
        userToken: token.raw,
      }),
    );
  }, []);

  useEffect(() => {
    const {data, error, errorMessage} = responseSelector(modelGetCargos);

    if (error) {
      dispatch(getCargosDuck.actions.clear());
      onError(errorMessage);
    }

    if (data) {
      const cargos = data.items;

      const datosAuxOptions = prepareDatosAuxOptions(cargos);

      setCargosOptions(datosAuxOptions);

      dispatch(getCargosDuck.actions.clear());
    }
  }, [modelGetCargos]);
  function agregarExp() {
    crearExperiencia();
  }

  function crearExperiencia() {
    const data = {
      userToken: token.raw,
      candidatoIdNumerico,
      empresaIdNumerico: empresaOption?.value,
      observacion, // texto libre de descripcion del cargo
      vigente,
      inicioFecha,
      finFecha: vigente ? null : finFecha,
      salario: salario ? String(salario) : null,
      condicionesActuales,
      cargoIdNumerico: cargoOptionExp?.value,
      rubroIdNumerico: rubroOption?.value,
      tipoEmpleo: tipoEmpleoOption?.value,
      salidaMotivoIdNumerico: vigente ? null : salidaMotivoOption?.value,
    };

    dispatch(crearCandidatoExpThunk(data));
  }

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelCrearCandidatoExp);

    if (error) {
      dispatch(crearCandidatoExpDuck.actions.clear());
      onError(errorMessage);
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      dispatch(crearCandidatoExpDuck.actions.clear());

      onSuccess();
    }
  }, [modelCrearCandidatoExp]);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelGetRubros);

    if (error) {
      dispatch(getRubrosDuck.actions.clear());
      onError(errorMessage);
    }

    if (data) {
      // log({ 'modelGetRubros.useEffect.data': data });

      const datosAuxOptions = prepareDatosAuxOptions(data.items);
      // log({ datosAuxOptions });

      setRubrosOptions(datosAuxOptions);

      dispatch(getRubrosDuck.actions.clear());
    }
  }, [modelGetRubros]);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelGetSalidaMotivos);

    if (error) {
      dispatch(getSalidaMotivosDuck.actions.clear());
      onError(errorMessage);
    }

    if (data) {
      // log({ 'modelGetSalidaMotivos.useEffect.data': data });

      const datosAuxOptions = prepareDatosAuxOptions(data.items);
      // log({ datosAuxOptions });

      setSalidaMotivoOptions(datosAuxOptions);

      dispatch(getSalidaMotivosDuck.actions.clear());
    }
  }, [modelGetSalidaMotivos]);

  return (
    <div>
      <Alert
        title="Observacion"
        type={alertTypes.info}
        text="El candidato debe tener al menos 1 experiencia para crear una nota"
        closable={false}
      />
      <h4>Experiencia laboral</h4>
      <EmpresaAutocomplete
        label="Empresa"
        token={token}
        initialSelectedEmpresaLabel={
          !empresaOption || empresaOption?.value == null
            ? 'Sin empresa seleccionada'
            : toTitleCase(empresaOption?.label)
        }
        onSelectEmpresa={empresa => {
          // TODO: simplemente seleccionar el _id.
          // Ya no hace falta que sea un option (label y value).
          setEmpresaOption({
            value: empresa.idNumerico,
            label: empresa.nombre,
          });
        }}
      />

      <hr />

      <SelectInput
        label="Cargo"
        value={cargoOptionExp}
        options={cargosOptions}
        setValue={setCargoOptionExp}
        required
      />

      <hr />

      <SelectInput
        label="Rubro"
        value={rubroOption}
        options={rubrosOptions}
        setValue={setRubroOption}
      />

      <TextArea
        label="Descripción del cargo"
        value={observacion}
        setValue={setObservacion}
      />

      <SelectInput
        label="Tipo de empleo"
        value={tipoEmpleoOption}
        options={empleoTipoOptionsForCandExp}
        setValue={setTipoEmpleoOption}
        required
      />

      <MonedaInputV2
        label="Salario percibido"
        initialValue={salario}
        setValue={setSalario}
        selectorMonedaDisabled={true}
      />

      <TextArea
        label="Condiciones actuales en la empresa"
        value={condicionesActuales}
        setValue={setCondicionesActuales}
      />

      <CheckBox
        checked={vigente}
        text="¿Actualmente aquí?"
        onChange={setVigente}
      />

      <DateInput
        label="Fecha de inicio"
        selected={inicioFecha}
        onChange={setInicioFecha}
      />

      {!vigente && (
        <>
          <DateInput
            label="Fecha de fin"
            selected={finFecha}
            onChange={setFinFecha}
          />
          <SelectInput
            label="Motivo de salida"
            value={salidaMotivoOption}
            options={salidaMotivoOptions}
            setValue={setSalidaMotivoOption}
          />
        </>
      )}

      <ButtonWithLoading type="success" text={'Guardar'} submit={agregarExp} />
    </div>
  );
};
